import { useEffect, useRef, useState, useContext, useCallback } from "react";
import Breadcrumb from "../breacrumb/breadcrumb";

import styles from "./Register.module.css";
import * as publicApi from "../../../service/publicApi";
import { HashLoader } from "react-spinners";
import Select from "../../material/select/SelectV2";
import Button from "../../material/button/Button";
import { useLocation, useNavigate } from "react-router-dom";
import * as regex from "../../../service/regex";

import { CurrentUserContext } from "../../../App";
import ModalPermission from "../../material/modal/ModalPermission";
import ModalTermsService from "../../material/modal/ModalTermsService";
import { convertToYMD } from "../../utility/Helper";

// Permission
import { permission, pathRole } from "./permission";

// Information
import InformationRegistration from "./information";
import AddressRegistration from "./address";
import PasswordRegistration from "./password";
import HospitalRegistration from "./hospital";
import LicenseRegistration from "./license";
import LabRegistration from "./lab";
import PositionRegistration from "./position";
import RoleRegistration from "./role";
import LaboratoryRegistration from "./laboratory";
import PolicyRegistration from "./policy";
import { RedirectCode400 } from "../../RedirectCode400";
import moment from "moment";

import {
  clickGetLoginMohPromtp,
  clickGetOauthUrl,
  clickGetLoginHealthID,
  clickGetLoginProviderID,
} from "./service/service";

function Register() {
  const [recaptchaValue, setRecaptchaValue] = useState(null);
  const [recaptchaCheck, setrecaptchaCheck] = useState(false);

  const { userRole, setIsMessage } = useContext(CurrentUserContext);
  const [onesDid, setOnesDid] = useState("");
  const [mohpromtId, setMohpromtId] = useState("");
  const [healthId, setHealthId] = useState("");
  const [providerId, setProviderId] = useState("");
  const [registerToken, setRegisterToken] = useState("");
  const [thaiD, setThaiD] = useState("");
  const [access_token, setAccessToken] = useState("");
  const [loading, setLoading] = useState(false);

  const [check, setCheck] = useState(false);
  const [userType, setUserType] = useState("PATIENT"); // ไม่น่าเกี่ยว
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [pendingOAuthFn, setPendingOAuthFn] = useState(null);
  const [pid, setPid] = useState("");
  const [pname, setPname] = useState("");
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [laserId, setLaserId] = useState("");
  const [gender, setGender] = useState("");
  const [birthday, setBirthday] = useState(null);
  const [address, setAddress] = useState("");
  const [moo, setMoo] = useState("");
  const [soy, setSoy] = useState("");
  const [road, setRoad] = useState("");
  const [postCode, setPostCode] = useState("");
  const [subDistrictId, setSubDistrictId] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [medicalType, setMedicalType] = useState(""); // Type of license doctor
  const [licenseNumber, setLicenseNumber] = useState(""); // license doctor
  const [position, setPosition] = useState("");
  const [hospitalId, setHospitalId] = useState("");
  const [labId, setLabId] = useState("");
  const [attachFile, setAttachFile] = useState(null);
  const [laboratoryName, setLaboratoryName] = useState("");
  const [labAddress, setLabAddress] = useState("");
  const [labMoo, setLabMoo] = useState("");
  const [labSoy, setLabSoy] = useState("");
  const [labRoad, setLabRoad] = useState("");
  const [labProvinceId, setLabProvinceId] = useState("");
  const [labDistrictId, setLabDistrictId] = useState("");
  const [labSubDistrictId, setLabSubDistrictId] = useState("");
  const [labPostCode, setLabPostCode] = useState("");
  const [analystCheck, setAnalystCheck] = useState(false);
  const [approverCheck, setApproverCheck] = useState(false);
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [personalInformation, setPersonalInformation] = useState(false);
  const [consentForm, setConsentForm] = useState(false);
  const [permissionEmail, setPermissionEmail] = useState(false);
  const nav = useNavigate();
  const location = useLocation();
  const inputFileRef = useRef(null);

  const [isVerified, setIsVerified] = useState(false); // verify PID

  // Disable
  const [disablePid, setDisablePid] = useState(false);
  const [disableLaser, setDisableLaser] = useState(false);
  const [disablePname, setDisablePname] = useState(false);
  const [disableFname, setDisableFname] = useState(false);
  const [disableLname, setDisableLname] = useState(false);
  const [disableGender, setDisableGender] = useState(false);
  const [disableBirthDate, setDisableBirthDate] = useState(false);
  const [disablePostCode, setDisablePostCode] = useState(false);
  const [disablePhone, setDisablePhone] = useState(false);
  const [disableEmail, setDisableEmail] = useState(false);
  const [disablePassword, setDisablePassword] = useState(false);
  const [disableConfirmPassword, setDisableConfirmPassword] = useState(false);

  // Disable Doctor and Hospital personal
  const [disableHospitalId, setDisableHospitalId] = useState(false);

  const [openModalInformation, setOpenModalInformation] = useState(false);
  const [openModalConsentForm, setOpenModalConsentForm] = useState(false);

  let userTypeList = [
    {
      key: "PATIENT",
      value: "ลงทะเบียนสำหรับประชาชนทั่วไป",
    },
    {
      key: "MEDICAL_PERSONNEL",
      value: "ลงทะเบียนสำหรับแพทย์หรือเภสัชกร",
    },
    {
      key: "LABORATORY_ADMIN",
      value: "ลงทะเบียนสำหรับผู้ดูแลห้องปฏิบัติการ",
    },
    {
      key: "LABORATORY_PERSONNEL",
      value: "ลงทะเบียนสำหรับผู้ปฏิบัติงานในห้องปฏิบัติการ",
    },
    {
      key: "HOSPITAL_PERSONNEL",
      value: "ลงทะเบียนสำหรับเจ้าหน้าที่โรงพยาบาล",
    },
  ];

  const checkExpireToken = (expire) => {
    //console.log("expire");
    //console.log(expire);
    let diff = moment().diff(expire, "seconds");
    //console.log(diff);
    if (diff >= 0) {
      return false;
    } else {
      return true;
    }
  };

  useEffect(() => {
    if (userRole === null) {
    } else {
      const tokenExpireAuth = localStorage.getItem("expire_login_user");
      if (checkExpireToken(tokenExpireAuth)) {
        nav(RedirectCode400());
        if (!tokenExpireAuth) {
        } else {
          window.location.reload();
        }
        return;
      }
    }
  }, [userRole]);

  useEffect(() => {
    if (isVerified) {
      setIsVerified(false);
    }
  }, [userType]);

  // FilterData when login with ThaiD or หมอพร้อม
  const filterData = useCallback(() => {
    const data = location.state;
    if (!data) return;

    setPid(data.pid || "");
    setPname(data.pname || "");
    setFname(data.fname || "");
    setLname(data.lname || "");
    setGender(data.pname === "นาย" ? "male" : "female" || "");
    setPhoneNumber(data.phoneNumber || data.phone_number || "");
    setEmail(data.email || "");
    setAccessToken(data.access_token || "");
    // Health ID / Provider ID: signed proof of the verified pid (replaces laser code)
    setRegisterToken(data.registerToken || "");

    if (data.dayOB && data.monthOB && data.yearOB) {
      setBirthday(new Date(`${data.yearOB}-${data.monthOB}-${data.dayOB}`));
    } else if (data.birthday) {
      setBirthday(new Date(data.birthday));
    }

    const addr = data.current_address || data;
    setAddress(addr.address || "");
    setMoo(addr.village_number || addr.moo || "");
    setSoy(addr.alley || addr.soy || "");
    setRoad(addr.road || "");
    setSubDistrictId(addr.sub_district_id || addr.subDistrictId || "");
    setPostCode(addr.post_code || addr.postCode || "");

    if (
      data.type === "register_mohpromt" ||
      data.type === "register_thaiD" ||
      data.type === "register_health_id" ||
      data.type === "register_provider_id" ||
      data.check === true
    ) {
      setCheck(true);
      setDisableLaser(true);
      setDisableFname(true);
      setDisableLname(true);
      setDisableGender(!!data.gender);
      setDisableBirthDate(true);
      setDisablePname(true);
      setDisableGender(true);

      setDisablePassword(false);
      setDisableConfirmPassword(false);

      if (data.type === "register_mohpromt") setMohpromtId(data.mohpromtId);
      if (data.type === "register_thaiD") setThaiD(data.thaiD);
      if (data.type === "register_health_id") setHealthId(data.healthId || "");
      if (data.type === "register_provider_id")
        setProviderId(data.providerId || "");
    }

    const type = data.userType || data.role;
    setUserType(type);

    if (type === "MEDICAL_PERSONNEL" || type === "HOSPITAL_PERSONNEL") {
      setHospitalId(data.hospitalId || data.hospital?.hospital_id || "");
      if (type === "MEDICAL_PERSONNEL") {
        setLicenseNumber(data.licenseNumber || data.license_number || "");
        setMedicalType(data.medicalType || data.medical_type || "");
      }
    }

    if (type === "LABORATORY_PERSONNEL" || type === "LABORATORY_ADMIN") {
      setPosition(data.position || "");
      setLicenseNumber(data.licenseNumber || data.license_number || "");
      setMedicalType(data.medicalType || data.medical_type || "");
      setAttachFile(data.attachFile || data.attachment_file || null);

      const roles = data.staff_role || [];
      setAnalystCheck(roles.includes("ANALYST") || !!data.analystCheck);
      setApproverCheck(roles.includes("APPROVER") || !!data.approverCheck);

      if (type === "LABORATORY_PERSONNEL") {
        setLabId(data.labId || data.laboratory?.laboratory_id || "");
      } else {
        const lab = data.laboratory || {};
        setLaboratoryName(lab.laboratory_name || "");
        setLatitude(lab.location?.latitude || data.latitude || "");
        setLongitude(lab.location?.longitude || data.longitude || "");

        const labAddr = lab.current_address || {};
        setLabAddress(labAddr.address || "");
        setLabMoo(labAddr.village_number || "");
        setLabSoy(labAddr.alley || "");
        setLabRoad(labAddr.road || "");
        setLabSubDistrictId(labAddr.sub_district_id || "");
        setLabPostCode(labAddr.post_code || "");
      }
    }
  }, [location]);

  // Call API และ Initialize Data
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        // console.log("Initialize Registration Form");
      } catch (err) {
        console.error("Fetch Data Error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData().then(() => {
      if (location.state) {
        filterData();
      }
    });

    return () => {
      // console.log("Cleanup Registration Page");
    };
  }, [location.state, filterData]);

  // Upload File
  const inputFileChange = async (event) => {
    if (event.target.files[0]) {
      let fileObj = event.target.files && event.target.files[0];

      let formData = new FormData();
      formData.append("file", fileObj);
      formData.append("file_name", fileObj.name);

      setLoading(true);
      let res = await publicApi.attachment(formData);
      // console.log(res);
      setLoading(false);
      if (res) {
        if (res["data"]["code"] === 200) {
          // console.log(res["data"]["file"]);
          setAttachFile(res["data"]["file"]);
        } else {
          setIsMessage({
            type: "warning",
            data: res["data"]["message_th"] || res["data"]["message"],
          });
        }
      } else {
        setIsMessage({
          type: "error",
          data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
        });
      }
    } else {
      return;
    }
  };

  const backButtonClick = () => {
    nav("/login");
  };

  // Submit
  const submitButtonClick = async () => {
    // validate recaptcha
    if (!recaptchaValue) {
      setrecaptchaCheck(true);
      setIsMessage({ type: "warning", data: "กรุณายืนยัน reCAPTCHA" });
      return;
    }

    if (!personalInformation) {
      setIsMessage({
        type: "warning",
        data: "กรุณายอมรับ นโยบายการเข้าใช้งานเว็บไซต์",
      });
      return;
    }

    if (!consentForm) {
      setIsMessage({
        type: "warning",
        data: "กรุณายอมรับ นโยบายคุ้มครองข้อมูลส่วนบุคคล",
      });
      return;
    }

    // validate type
    if (!userType) {
      setIsMessage({
        type: "warning",
        data: "กรุณาเลือกประเภทของผู้เข้าใช้งาน",
      });
      return;
    }

    // validate information must have
    if (!pid) {
      setIsMessage({
        type: "warning",
        data: "กรุณากรอกเลขบัตรประจำตัวประชาชน",
      });
      return;
    }

    if (check === false && !laserId) {
      setIsMessage({
        type: "warning",
        data: "กรุณากรอกเลขหลังบัตรประจำตัวประชาชน",
      });
      return;
    }

    if (!pname) {
      setIsMessage({ type: "warning", data: "กรุณาเลือกคำนำหน้า" });
      return;
    }

    if (!fname) {
      setIsMessage({ type: "warning", data: "กรุณากรอกชื่อ" });
      return;
    }

    if (!lname) {
      setIsMessage({ type: "warning", data: "กรุณากรอกนามสกุล" });
      return;
    }

    if (!gender) {
      setIsMessage({ type: "warning", data: "กรุณาเลือกเพศ" });
      return;
    }

    if (!birthday) {
      setIsMessage({ type: "warning", data: "กรุณาเลือกวันเกิด" });
      return;
    }

    if (!postCode) {
      setIsMessage({ type: "warning", data: "กรุณากรอกรหัสไปรษณีย์" });
      return;
    }

    if (!phoneNumber) {
      setIsMessage({ type: "warning", data: "กรุณากรอกเบอร์โทร" });
      return;
    }

    if (check === false && !password) {
      setIsMessage({ type: "warning", data: "กรุณากรอกรหัสผ่าน" });
      return;
    }

    if (check === false && !confirmPassword) {
      setIsMessage({ type: "warning", data: "กรุณากรอกยืนยันรหัสผ่าน" });
      return;
    }

    if (check === false && password !== confirmPassword) {
      setIsMessage({ type: "warning", data: "รหัสผ่านไม่ตรงกัน" });
      return;
    }

    // role
    if (userType === "MEDICAL_PERSONNEL") {
      if (!licenseNumber) {
        setIsMessage({ type: "warning", data: "กรุณากรอกเลขใบประกอบวิชาชีพ" });
        return;
      }

      if (!medicalType) {
        setIsMessage({
          type: "warning",
          data: "กรุณาเลือกประเภทวิชาชีพเวชกรรม",
        });
        return;
      }

      if (!hospitalId) {
        setIsMessage({ type: "warning", data: "กรุณาเลือกโรงพยาบาลที่สังกัด" });
        return;
      }
    }

    if (userType === "HOSPITAL_PERSONNEL") {
      if (!hospitalId) {
        setIsMessage({ type: "warning", data: "กรุณาเลือกโรงพยาบาลที่สังกัด" });
        return;
      }
    }

    if (userType === "LABORATORY_PERSONNEL") {
      if (!labId) {
        setIsMessage({ type: "warning", data: "กรุณาเลือกแลป" });
        return;
      }
    }

    if (
      userType === "LABORATORY_PERSONNEL" ||
      userType === "LABORATORY_ADMIN"
    ) {
      if (!position) {
        setIsMessage({ type: "warning", data: "กรุณากรอกตำแหน่ง" });
        return;
      }

      if (!analystCheck && !approverCheck) {
        setIsMessage({ type: "warning", data: "กรุณาเลือกหน้าที่" });
        return;
      }

      // if (!attachFile) {
      //   console.log(attachFile);
      //   setIsMessage("กรุณาแนบไฟล์ใบประกอบวิชาชีพ");
      //   return;
      // }
    }

    if (userType === "LABORATORY_ADMIN") {
      if (!laboratoryName) {
        setIsMessage({
          type: "warning",
          data: "กรุณากรอกชื่อห้องปฏิบัติการ/โรงพยาบาลต้นสังกัด",
        });
        return;
      }

      if (!labAddress) {
        setIsMessage({ type: "warning", data: "กรุณากรอกที่อยู่" });
        return;
      }

      if (!labMoo) {
        setIsMessage({ type: "warning", data: "กรุณากรอกหมู่" });
        return;
      }

      if (!labSoy) {
        setIsMessage({ type: "warning", data: "กรุณากรอกซอย" });
        return;
      }

      if (!labRoad) {
        setIsMessage({ type: "warning", data: "กรุณากรอกถนน" });
        return;
      }

      if (!labProvinceId) {
        setIsMessage({ type: "warning", data: "กรุณาเลือกจังหวัด" });
        return;
      }

      if (!labDistrictId) {
        setIsMessage({ type: "warning", data: "กรุณาเลือกอำเภอ" });
        return;
      }

      if (!labSubDistrictId) {
        setIsMessage({ type: "warning", data: "กรุณาเลือกตำบล" });
        return;
      }

      if (!labPostCode) {
        setIsMessage({ type: "warning", data: "กรุณากรอกรหัสไปรษณีย์" });
        return;
      }

      if (!latitude && !longitude) {
        setIsMessage({ type: "warning", data: "กรุณาเลือกตำแหน่งที่ตั้ง" });
        return;
      }
    }

    // set Body begin with patient
    let body = {
      mohpromt_account_id: mohpromtId || "",
      health_id_account_id: healthId || "",
      provider_id_account_id: providerId || "",
      register_token: registerToken || "",
      ones_did: onesDid || "",
      thai_d: thaiD || "",
      access_token: access_token || "",
      pname: pname,
      fname: fname,
      lname: lname,
      pid: pid,
      gender: gender,
      birthday_fill: check === true ? birthday : convertToYMD(birthday),
      role: userType, // role type
      laser: laserId,
      current_address: {
        address: address,
        village_number: moo,
        alley: soy,
        road: road,
        sub_district_id: subDistrictId,
        post_code: postCode,
      },
      phone_number: phoneNumber,
      email: email,
      username: userType,
      password: password,
      confirm_password: confirmPassword,
      permission: {
        policy_personal_information: personalInformation,
        consent_form: consentForm,
        access_data_every_time: false,
        access_data_some_time: false,
        access_to_email: permissionEmail,
      },
      check: check,
    };

    if (userType === "PATIENT") {
      setLoading(true);
      let res = await publicApi.registerPatient(body);
      setLoading(false);
      if (res) {
        if (res["data"]["code"] === 200) {
          setIsMessage({ type: "success", data: "สมัครใช้งานสำเร็จ" });
          nav("/login");
        } else {
          setIsMessage({
            type: "warning",
            data: res["data"]["message_th"] || res["data"]["message"],
          });
        }
      } else {
        setIsMessage({
          type: "error",
          data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
        });
      }
    }

    if (userType === "MEDICAL_PERSONNEL") {
      body.hospital_id = hospitalId;
      body.license_number = licenseNumber;
      body.medical_type = medicalType;

      setLoading(true);
      let res = await publicApi.registerMedicalPersonnel(body);
      setLoading(false);
      if (res) {
        if (res["data"]["code"] === 200) {
          setIsMessage({ type: "success", data: "สมัครใช้งานสำเร็จ" });
          nav("/login");
        } else {
          setIsMessage({
            type: "warning",
            data: res["data"]["message_th"] || res["data"]["message"],
          });
        }
      } else {
        setIsMessage({
          type: "error",
          data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
        });
      }
    }

    if (userType === "HOSPITAL_PERSONNEL") {
      body.hospital_id = hospitalId;

      setLoading(true);
      let res = await publicApi.registerHospitalPersonnel(body);
      setLoading(false);
      if (res) {
        if (res["data"]["code"] === 200) {
          setIsMessage({ type: "success", data: "สมัครใช้งานสำเร็จ" });
          nav("/login");
        } else {
          setIsMessage({
            type: "warning",
            data: res["data"]["message_th"] || res["data"]["message"],
          });
        }
      } else {
        setIsMessage({
          type: "error",
          data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
        });
      }
    }

    if (userType === "LABORATORY_PERSONNEL") {
      let roles = [];
      if (analystCheck) roles.push("ANALYST");
      if (approverCheck) roles.push("APPROVER");

      body.staff_role = roles;
      body.laboratory_id = labId;
      body.hospital_id = hospitalId;
      body.license_number = licenseNumber;
      body.medical_type = medicalType;
      body.position = position;
      body.attachment_file = attachFile;

      setLoading(true);
      let res = await publicApi.registerLaboratoryPersonnel(body);
      setLoading(false);
      if (res) {
        if (res["data"]["code"] === 200) {
          setIsMessage({ type: "success", data: "สมัครใช้งานสำเร็จ" });
          nav("/login");
        } else {
          setIsMessage({
            type: "warning",
            data: res["data"]["message_th"] || res["data"]["message"],
          });
        }
      } else {
        setIsMessage({
          type: "error",
          data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
        });
      }
    }

    if (userType === "LABORATORY_ADMIN") {
      let roles = [];
      if (analystCheck) roles.push("ANALYST");
      if (approverCheck) roles.push("APPROVER");

      body.staff_role = roles;
      body.hospital_id = hospitalId;
      body.license_number = licenseNumber;
      body.medical_type = medicalType;
      body.position = position;
      body.attachment_file = attachFile;
      body.laboratory = {
        laboratory_name: laboratoryName,
        current_address: {
          address: labAddress,
          village_number: labMoo,
          alley: labSoy,
          road: labRoad,
          sub_district_id: labSubDistrictId,
          post_code: labPostCode,
        },
        location: {
          latitude: Number(latitude),
          longitude: Number(longitude),
        },
      };

      setLoading(true);
      let res = await publicApi.registerLaboratoryAdmin(body);
      setLoading(false);
      if (res) {
        if (res["data"]["code"] === 200) {
          setIsMessage({ type: "success", data: "สมัครใช้งานสำเร็จ" });
          nav("/login");
        } else {
          setIsMessage({
            type: "warning",
            data: res["data"]["message_th"] || res["data"]["message"],
          });
        }
      } else {
        setIsMessage({
          type: "error",
          data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
        });
      }
    }
  };

  // Path
  const pathItems = [
    userType
      ? [
          { name: "หน้าหลัก", url: `/` },
          { name: "สมัครใช้งาน", url: `` },
          { name: pathRole(userType) },
        ]
      : [
          { name: "หน้าหลัก", url: `/` },
          { name: "สมัครใช้งาน", url: `` },
        ],
  ].flat();

  // Recaptcha
  const handleRecaptchaChange = (value) => {
    setrecaptchaCheck(false);
    setRecaptchaValue(value);
  };

  // Format File size
  const formatFileSize = (data) => {
    let kb = data / 1024;
    let kbFormatted = kb.toFixed(1);
    let kbData = Math.ceil(kbFormatted);

    return <>{kbData} KB</>;
  };

  const iconDot = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="currentColor"
        class="icon icon-tabler icons-tabler-filled icon-tabler-point"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M12 7a5 5 0 1 1 -4.995 5.217l-.005 -.217l.005 -.217a5 5 0 0 1 4.995 -4.783z" />
      </svg>
    );
  };

  // Function Check Information
  const handleCheckInformation = async () => {
    try {
      setLoading(true);
      const res = await publicApi.checkInformation({ pid, role: userType });

      const hasData = res?.data?.code === 200;
      const data = res?.data?.data || {};

      setLoading(false);

      const setField = (setter, disableSetter, value) => {
        setter(value ?? "");
        disableSetter(!!value);
      };

      if (res?.data?.code === 200) {
        setIsMessage({ type: "success", data: `${res?.data?.message_th}` });
        setDisableLaser(true);

        setField(setPname, setDisablePname, data.pname);
        setField(setFname, setDisableFname, data.fname);
        setField(setLname, setDisableLname, data.lname);
        setField(setGender, setDisableGender, data.gender);
        setField(setBirthday, setDisableBirthDate, data.birthday);
        setField(
          setPostCode,
          setDisablePostCode,
          data.current_address?.post_code,
        );
        setField(setPhoneNumber, setDisablePhone, data.phone_number);
        setField(setEmail, setDisableEmail, data.email);

        if (data.gender) {
          setDisablePassword(true);
          setDisableConfirmPassword(true);
        }

        if (data?.hospital?.hospital_id) {
          setField(
            setHospitalId,
            setDisableHospitalId,
            data.hospital.hospital_id,
          );
        }

        if (data?.current_address?.address) {
          setAddress(data?.current_address?.address);
        }

        if (data?.current_address?.village_number) {
          setMoo(data?.current_address?.village_number);
        }

        if (data?.current_address?.alley) {
          setSoy(data?.current_address?.alley);
        }

        if (data?.current_address?.road) {
          setRoad(data?.current_address?.road);
        }

        setCheck(true);
        setIsVerified(true);
      } else if (res?.data?.code === 204) {
        setIsMessage({ type: "success", data: `${res?.data?.message_th}` });
        setDisableLaser(false);

        setField(setPname, setDisablePname, "");
        setField(setFname, setDisableFname, "");
        setField(setLname, setDisableLname, "");
        setField(setGender, setDisableGender, "");
        setField(setBirthday, setDisableBirthDate, "");
        setField(setPostCode, setDisablePostCode, "");
        setField(setPhoneNumber, setDisablePhone, "");
        setField(setEmail, setDisableEmail, "");

        setField(setHospitalId, setDisableHospitalId, "");

        setDisablePassword(false);
        setDisableConfirmPassword(false);

        setCheck(false);
        setIsVerified(true);
      } else {
        setIsMessage({ type: "warning", data: `${res?.data?.message_th}` });
      }
    } catch (err) {
      console.error("Check information error:", err);
    }
  };

  const roleList = [
    {
      value: "PATIENT",
      name: "ลงทะเบียนสำหรับประชาชนทั่วไป",
    },
    {
      value: "MEDICAL_PERSONNEL",
      name: "ลงทะเบียนสำหรับแพทย์หรือเภสัชกร",
    },
    {
      value: "LABORATORY_ADMIN",
      name: "ลงทะเบียนสำหรับผู้ดูแลห้องปฏิบัติการ",
    },
    {
      value: "LABORATORY_PERSONNEL",
      name: "ลงทะเบียนสำหรับผู้ปฏิบัติงานในห้องปฏิบัติการ",
    },
    {
      value: "HOSPITAL_PERSONNEL",
      name: "ลงทะเบียนสำหรับเจ้าหน้าที่โรงพยาบาล",
    },
  ];

  return (
    <>
      <div className="global-page">
        <Breadcrumb pathItems={pathItems} />
        <div className={styles.content}>
          <div className="w-full flex justify-center flex-col items-center">
            <span className="text-3xl md:text-[18px] text-[#000000] font-bold mt-[3rem] my-2">
              สมัครใช้งาน
            </span>
            <div className="flex justify-center flex-col text-center gap-2">
              <div>
                <span className="text-[1.325rem]">
                  กรุณากรอกข้อมูลให้ครบถ้วน
                </span>
              </div>
              <span>
                เพิ่มข้อมูลที่อยู่และตั้งค่าบัญชีเพื่อเข้าใช้งานในครั้งถัดไป
              </span>
            </div>
          </div>

          <div className="flex justify-center">
            <div
              className={styles.formContainerDefault}
              style={{ marginTop: 30, marginBottom: 30 }}
            >
              <label htmlFor={`user_type`} className="sr-only">
                เลือกประเภทของผู้เข้าใช้งาน
              </label>
              <Select
                value={userType}
                setValue={setUserType}
                list={roleList}
                id="user_type"
              />
              {/* <select
                onChange={(e) => {
                  setUserType(e.target.value);
                }}
                value={ userType }
                style={{
                  width: "100%",
                  height: "40px",
                  paddingLeft: "15px",
                  paddingRight: "15px",
                  boxSizing: "border-box",
                  background: "#ffffff",
                  border: "1px solid #A9A7B1",
                  borderRadius: "4px",
                  display: "flex",
                  alignItems: "center",
                  overflow: "hidden",
                  marginTop: "4px",
                  color: "black",
                  appearance: "none",
                }}   
                id="user_type"
              >
                <option value={"PATIENT"}>ลงทะเบียนสำหรับประชาชนทั่วไป</option>
                <option value={"MEDICAL_PERSONNEL"}>
                  ลงทะเบียนสำหรับแพทย์หรือเภสัชกร
                </option>
                <option value={"LABORATORY_ADMIN"}>
                  ลงทะเบียนสำหรับผู้ดูแลห้องปฏิบัติการ
                </option>
                <option value={"LABORATORY_PERSONNEL"}>
                  ลงทะเบียนสำหรับผู้ปฏิบัติงานในห้องปฏิบัติการ
                </option>
                <option value={"HOSPITAL_PERSONNEL"}>
                  ลงทะเบียนสำหรับเจ้าหน้าที่โรงพยาบาล
                </option>
              </select> */}
            </div>
          </div>

          <div className={styles.optionContent}>
            <div className={styles.otherLogin}>
              <button
                className={`${styles.card} ${styles.pointer}`}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gab: 20,
                  border: "1px solid #01169B",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "52px",
                }}
                onClick={() => {
                  if (!userType) {
                    setIsMessage({
                      type: "warning",
                      data: "กรุณาเลือกประเภทของผู้เข้าใช้งาน",
                    });
                    return;
                  }
                  if (userType === "PATIENT") {
                    setPendingOAuthFn(() => () => clickGetOauthUrl(userType));
                    setShowTermsModal(true);
                  } else {
                    clickGetOauthUrl(userType);
                  }
                }}
              >
                <img
                  style={{ width: 30, height: "auto" }}
                  src={require("../../../asset/icon/thaiId.svg").default}
                  alt={`รูปประกอบThaID`}
                />
                <span className={styles.text} style={{ color: "#00169B" }}>
                  เข้าใช้งานด้วย ThaID
                </span>
              </button>

              <button
                className={`${styles.card} ${styles.pointer}`}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gab: 20,
                  border: "1px solid #046839",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "52px",
                }}
                onClick={() => {
                  if (!userType) {
                    setIsMessage({
                      type: "warning",
                      data: "กรุณาเลือกประเภทของผู้เข้าใช้งาน",
                    });
                    return;
                  }
                  if (userType === "PATIENT") {
                    setPendingOAuthFn(
                      () => () => clickGetLoginMohPromtp(userType),
                    );
                    setShowTermsModal(true);
                  } else {
                    clickGetLoginMohPromtp(userType);
                  }
                }}
              >
                <img
                  style={{ width: 30, height: "auto" }}
                  src={require("../../../asset/icon/mooprom.svg").default}
                  alt={`รูปประกอบหมอพร้อม`}
                />
                <span className={styles.text} style={{ color: "#046839" }}>
                  {" "}
                  เข้าใช้งานด้วยหมอพร้อม{" "}
                </span>
              </button>

              <button
                className={`${styles.card} ${styles.pointer}`}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gab: 20,
                  border: "1px solid #0E7490",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "52px",
                }}
                onClick={() => {
                  if (userType === "PATIENT") {
                    setPendingOAuthFn(() => clickGetLoginHealthID);
                    setShowTermsModal(true);
                  } else {
                    setIsMessage({
                      type: "warning",
                      data: "สามารถเข้าใช้งานด้วย Health ID ได้เฉพาะผู้ใช้งานประเภทประชาชนทั่วไปเท่านั้น",
                    });
                    return;
                  }
                }}
              >
                <img
                  style={{ width: 30, height: "auto" }}
                  src={require("../../../asset/icon/DID.svg").default}
                  alt={`รูปประกอบ Health ID`}
                />
                <span className={styles.text} style={{ color: "#0E7490" }}>
                  เข้าใช้งานด้วย Health ID
                </span>
              </button>

              <button
                className={`${styles.card} ${styles.pointer}`}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gab: 20,
                  border: "1px solid #7A1FA2",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "52px",
                }}
                onClick={() => {
                  if (
                    userType === "MEDICAL_PERSONNEL" ||
                    userType === "HOSPITAL_PERSONNEL" ||
                    userType === "LABORATORY_PERSONNEL" ||
                    userType === "LABORATORY_ADMIN" ||
                    userType === "EXECUTIVE" || 
                    userType === "ADMIN"
                  ) {
                    clickGetLoginProviderID(userType);
                  } else {
                    setIsMessage({
                      type: "warning",
                      data: "สามารถเข้าใช้งานด้วย Provider ID ได้เฉพาะผู้ใช้งานประเภทเจ้าหน้าที่โรงพยาบาล แพทย์ เภสัชกร เจ้าหน้าที่ห้องปฏิบัติการ และแอดมินเท่านั้น",
                    });
                    return;
                  }
                }}
              >
                <img
                  style={{ width: 30, height: "auto" }}
                  src={require("../../../asset/icon/MEDICALicon.svg").default}
                  alt={`รูปประกอบ Provider ID`}
                />
                <span className={styles.text} style={{ color: "#7A1FA2" }}>
                  เข้าใช้งานด้วย Provider ID
                </span>
              </button>
            </div>
          </div>

          <div className={styles.orContent}>
            <div className={styles.otherOr}>
              <div className={styles.line}></div>
              <span>หรือ</span>
              <div className={styles.line}></div>
            </div>
          </div>

          {userType && (
            <>
              {isVerified && (
                <>
                  {userType === "LABORATORY_PERSONNEL" && (
                    <LabRegistration labId={labId} setLabId={setLabId} />
                  )}
                </>
              )}

              {isVerified && (
                <>
                  {userType === "LABORATORY_ADMIN" && (
                    <LaboratoryRegistration
                      laboratoryName={laboratoryName}
                      setLaboratoryName={setLaboratoryName}
                      labAddress={labAddress}
                      setLabAddress={setLabAddress}
                      labMoo={labMoo}
                      setLabMoo={setLabMoo}
                      labSoy={labSoy}
                      setLabSoy={setLabSoy}
                      labRoad={labRoad}
                      setLabRoad={setLabRoad}
                      labProvinceId={labProvinceId}
                      setLabProvinceId={setLabProvinceId}
                      labDistrictId={labDistrictId}
                      setLabDistrictId={setLabDistrictId}
                      labSubDistrictId={labSubDistrictId}
                      setLabSubDistrictId={setLabSubDistrictId}
                      labPostCode={labPostCode}
                      setLabPostCode={setLabPostCode}
                      latitude={latitude}
                      setLatitude={setLatitude}
                      longitude={longitude}
                      setLongitude={setLongitude}
                      regex={regex}
                    />
                  )}
                </>
              )}

              <InformationRegistration
                pid={pid}
                setPid={setPid}
                laserId={laserId}
                setLaserId={setLaserId}
                disableLaser={disableLaser}
                pname={pname}
                setPname={setPname}
                disablePname={disablePname}
                fname={fname}
                setFname={setFname}
                disableFname={disableFname}
                lname={lname}
                setLname={setLname}
                disableLname={disableLname}
                gender={gender}
                setGender={setGender}
                disableGender={disableGender}
                birthday={birthday}
                setBirthday={setBirthday}
                disableBirthDate={disableBirthDate}
                regex={regex}
                handleCheckInformation={handleCheckInformation}
                setIsVerified={setIsVerified}
                isVerified={isVerified}
              />

              {isVerified && (
                <>
                  {(userType === "LABORATORY_PERSONNEL" ||
                    userType === "LABORATORY_ADMIN") && (
                    <PositionRegistration
                      position={position}
                      setPosition={setPosition}
                    />
                  )}
                </>
              )}

              {isVerified && (
                <>
                  {(userType === "LABORATORY_PERSONNEL" ||
                    userType === "LABORATORY_ADMIN" ||
                    userType === "MEDICAL_PERSONNEL") && (
                    <LicenseRegistration
                      medicalType={medicalType}
                      setMedicalType={setMedicalType}
                      licenseNumber={licenseNumber}
                      setLicenseNumber={setLicenseNumber}
                      placeholderType={`${userType === "MEDICAL_PERSONNEL" ? "ประเภทวิชาชีพเวชกรรม" : "ประเภทวิชาชีพเวชกรรม (ถ้ามี)"}`}
                      placeholderLicense={`${userType === "MEDICAL_PERSONNEL" ? "เลขใบประกอบวิชาชีพ" : "เลขใบประกอบวิชาชีพ (ถ้ามี)"}`}
                      labelType={`${userType === "MEDICAL_PERSONNEL" ? "ประเภทวิชาชีพเวชกรรม" : "ประเภทวิชาชีพเวชกรรม (ถ้ามี)"}`}
                      labelLicense={`${userType === "MEDICAL_PERSONNEL" ? "เลขใบประกอบวิชาชีพ" : "เลขใบประกอบวิชาชีพ (ถ้ามี)"}`}
                    />
                  )}
                </>
              )}

              {isVerified && (
                <>
                  {(userType === "HOSPITAL_PERSONNEL" ||
                    userType === "MEDICAL_PERSONNEL" ||
                    userType === "LABORATORY_PERSONNEL") && (
                    <HospitalRegistration
                      hospitalId={hospitalId}
                      setHospitalId={setHospitalId}
                      disableHospitalId={disableHospitalId}
                    />
                  )}
                </>
              )}

              {isVerified && (
                <>
                  <AddressRegistration
                    postCode={postCode}
                    setPostCode={setPostCode}
                    disablePostCode={disablePostCode}
                    phoneNumber={phoneNumber}
                    setPhoneNumber={setPhoneNumber}
                    disablePhone={disablePhone}
                    email={email}
                    setEmail={setEmail}
                    disableEmail={disableEmail}
                    regex={regex}
                  />
                </>
              )}

              {isVerified && (
                <>
                  {(userType === "LABORATORY_PERSONNEL" ||
                    userType === "LABORATORY_ADMIN") && (
                    <RoleRegistration
                      analystCheck={analystCheck}
                      setAnalystCheck={setAnalystCheck}
                      approverCheck={approverCheck}
                      setApproverCheck={setApproverCheck}
                      attachFile={attachFile}
                      setAttachFile={setAttachFile}
                      inputFileRef={inputFileRef}
                      inputFileChange={inputFileChange}
                      formatFileSize={formatFileSize}
                    />
                  )}
                </>
              )}

              {isVerified && (
                <>
                  <PasswordRegistration
                    password={password}
                    setPassword={setPassword}
                    disablePassword={disablePassword}
                    confirmPassword={confirmPassword}
                    setConfirmPassword={setConfirmPassword}
                    disableConfirmPassword={disableConfirmPassword}
                    regex={regex}
                  />
                </>
              )}
            </>
          )}

          {isVerified && (
            <>
              {userType !== "" ? (
                <>
                  <div
                    className={styles.formContainer}
                    style={{ gridTemplateColumns: "1fr" }}
                  >
                    {password.length > 0 && (
                      <ul className="ms-2 text-[0.95rem]">
                        <li
                          className={
                            password.length > 0
                              ? regex.validateLengthPassword(password)
                              : "text-[#8f8e8e]"
                          }
                        >
                          <div className="flex items-center">
                            <div className="w-[25px]">
                              {password.length > 0
                                ? regex.iconLengthPassword(password)
                                : iconDot()}
                            </div>
                            <span>
                              รหัสผ่านต้องมีความยาวอย่างน้อย 8 ตัวอักษร
                            </span>
                          </div>
                        </li>
                        <li
                          className={
                            password.length > 0
                              ? regex.validateNumberPassword(password)
                              : "text-[#8f8e8e]"
                          }
                        >
                          <div className="flex items-center">
                            <div className="w-[25px]">
                              {password.length > 0
                                ? regex.iconNumberPassword(password)
                                : iconDot()}
                            </div>
                            <span>
                              รหัสผ่านต้องมีตัวเลข 1-9 อย่างน้อย 1 ตัว
                            </span>
                          </div>
                        </li>
                        <li
                          className={
                            password.length > 0
                              ? regex.validateLowercasePassword(password)
                              : "text-[#8f8e8e]"
                          }
                        >
                          <div className="flex items-center">
                            <div className="w-[25px]">
                              {password.length > 0
                                ? regex.iconLowercasePassword(password)
                                : iconDot()}
                            </div>
                            <span>
                              รหัสผ่านต้องประกอบด้วยตัวอักษรพิมพ์เล็ก a-z
                              อย่างน้อย 1 ตัว
                            </span>
                          </div>
                        </li>
                        <li
                          className={
                            password.length > 0
                              ? regex.validateUppercasePassword(password)
                              : "text-[#8f8e8e]"
                          }
                        >
                          <div className="flex items-center">
                            <div className="w-[25px]">
                              {password.length > 0
                                ? regex.iconUppercasePassword(password)
                                : iconDot()}
                            </div>
                            <span>
                              รหัสผ่านต้องประกอบด้วยตัวพิมพ์ใหญ่ A-Z อย่างน้อย 1
                              ตัว
                            </span>
                          </div>
                        </li>
                      </ul>
                    )}
                  </div>

                  <PolicyRegistration
                    permissionEmail={permissionEmail}
                    setPermissionEmail={setPermissionEmail}
                    personalInformation={personalInformation}
                    setPersonalInformation={setPersonalInformation}
                    consentForm={consentForm}
                    setConsentForm={setConsentForm}
                    recaptchaCheck={recaptchaCheck}
                    handleRecaptchaChange={handleRecaptchaChange}
                    setOpenModalInformation={setOpenModalInformation}
                    setOpenModalConsentForm={setOpenModalConsentForm}
                  />

                  <div className={styles.buttonContainer}>
                    <Button
                      style={{
                        width: 140,
                        background: "#FFFFFF",
                        color: "#000",
                      }}
                      onClick={backButtonClick}
                    >
                      ย้อนกลับ
                    </Button>
                    <Button style={{ width: 140 }} onClick={submitButtonClick}>
                      ยืนยัน
                    </Button>
                  </div>
                </>
              ) : (
                <div className="block mb-[20px] w-full h-[10px]"> </div>
              )}
            </>
          )}

          {loading && (
            <>
              <div className=" min-h-[300px]">
                <div className="absolute inset-0 flex items-center justify-center">
                  <HashLoader color="#FF9768" />
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      {openModalInformation && (
        <ModalPermission
          onClose={() => setOpenModalInformation(false)}
          type={userType}
          value={permission}
          header="information"
        />
      )}

      {openModalConsentForm && (
        <ModalPermission
          onClose={() => setOpenModalConsentForm(false)}
          type={userType}
          value={permission}
          header="consentform"
        />
      )}

      <ModalTermsService
        show={showTermsModal}
        onConfirm={() => {
          setShowTermsModal(false);
          if (pendingOAuthFn) pendingOAuthFn();
          setPendingOAuthFn(null);
        }}
        onCancel={() => {
          setShowTermsModal(false);
          setPendingOAuthFn(null);
        }}
      />
    </>
  );
}

export default Register;
